// extracted by mini-css-extract-plugin
export var actionButton = "_rw-0";
export var actionMenuContainer = "_rw-i";
export var bubble = "_rw-2";
export var bubbleActionMenu = "_rw-j";
export var bubbleContext = "_rw-6";
export var bubbleItems = "_rw-7";
export var customer = "_rw-3";
export var divider = "_rw-8";
export var fileList = "_rw-9";
export var hiddenComment = "_rw-o";
export var infoAbove = "_rw-a";
export var internal = "_rw-4";
export var lightActionButton = "_rw-1";
export var link = "_rw-b";
export var merchant = "_rw-5";
export var message = "_rw-c";
export var profilePicture = "_rw-e";
export var quillToolbarContainer = "_rw-f";
export var senderDate = "_rw-g";
export var senderDateCustomer = "_rw-h";
export var senderName = "_rw-d";
export var time = "_rw-k";
export var uploadedImage = "_rw-l";
export var username = "_rw-m";
export var xsmall = "_rw-n";